let OTP_Type = {
  REGISTER: 1,
  RESET_PASSWORD: 2,
  CHANGE_MOBILE_NUMBER: 3
}

export { OTP_Type }
